module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"content":"Content","netlinking":"Netlinking","serp":"SERP","average":"Average"},"fr":{"content":"Contenu","netlinking":"Netlinking","serp":"SERP","average":"Moyenne"},"de":{"content":"Inhalt","netlinking":"Netzverlinkung","serp":"SERP","average":"Bedeuten"}}')
  delete Component.options._Ctor
}
